import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props), createElement("path", {
    d: 'M16.412 18.572V14.29h1.428V20H5v-5.71h1.428v4.282h9.984Z'
  }), createElement("path", {
    d: 'M7.857 17.145h7.137v-1.428H7.857v1.428ZM14.254 4l-1.146.852 4.26 5.727 1.146-.852L14.254 4Zm-3.54 3.377 5.484 4.567.913-1.097-5.484-4.567-.914 1.097ZM8.922 10.55l6.47 3.013.603-1.294-6.47-3.013-.603 1.294Zm-.925 3.344 6.985 1.469.294-1.398-6.985-1.468-.294 1.397Z'
  }));
};

export { component };
//# sourceMappingURL=ItStackoverflow-bab99027.js.map
